export enum TrendingDataPeriod {
  Now = 'now',
  Then = 'then'
}
